import gql from 'graphql-tag'

export default gql`
	query sendAbacus(
		$shopId: [ID]!
		$email: String!
		$datePeriod: FullDateTimeIntervalInput!
		$detailedExport: Boolean
	) {
		cashAssist {
			sendAbacus(shopId: $shopId, email: $email, datePeriod: $datePeriod, detailedExport: $detailedExport) {
				success
				messages
				error
			}
		}
	}

`
